import React, { useState, useEffect } from "react";
import Modal from "react-modal";

type Props = {
  isOpen: boolean;
  onRequestClose: () => void;
  currentImage: string;
  onUpload: (file: File | null) => void;
};

const ProfilePhotoModal: React.FC<Props> = ({
                                              isOpen,
                                              onRequestClose,
                                              currentImage,
                                              onUpload,
                                            }) => {
  const [selectedFile, setSelectedFile] = useState<File | null>(null);
  const [preview, setPreview] = useState<string | null>(null);

  useEffect(() => {
    if (!isOpen) {
      setSelectedFile(null);
      setPreview(null);
    }
  }, [isOpen]);

  const handleFileChange = (e: any) => {
    const file = e.target.files[0];
    if (!file) return;
    setSelectedFile(file);
    setPreview(URL.createObjectURL(file));
  };

  const handleUpload = () => {
    if (selectedFile) {
      onUpload(selectedFile);
      onRequestClose();
    }
  };

  return (
    <Modal
      isOpen={isOpen}
      onRequestClose={onRequestClose}
      className="pp-modal-content"
      overlayClassName="pp-modal-overlay"
    >
      <div className="pp-modal-close" onClick={onRequestClose}>
        ×
      </div>

      <h2 className="pp-modal-title">Change Profile Photo</h2>

      <div className="pp-image-wrapper">
        <img src={preview || currentImage} className="pp-modal-image" alt="Profile" />

        <button
          className="pp-remove-icon"
          onClick={() => {
            onUpload(null);
            onRequestClose();
          }}
        >
          ✕
        </button>
      </div>

      <div className="pp-btn-row">
        <input
          id="pp-choose-input"
          type="file"
          accept="image/*"
          onChange={handleFileChange}
          style={{ display: 'none' }}
        />

        <label htmlFor="pp-choose-input" className="pp-btn pp-btn-choose">
          Choose Photo
        </label>

        <button
          className={`pp-btn pp-btn-upload ${selectedFile ? 'enabled' : ''}`}
          disabled={!selectedFile}
          onClick={handleUpload}
        >
          Upload Photo
        </button>
      </div>
    </Modal>
  );
};

export default ProfilePhotoModal;